import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-background px-5 py-16 sm:py-20" data-id="element-119" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl text-center" data-id="element-120" data-mp="1o5q4gof8qm3o">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-subtle text-success" data-id="element-121" data-mp="222d9lehckiko">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-122" data-mp="1x5msqoxpxiy7" />
        </span>
        <h2 className="mt-6 font-display text-xl font-black uppercase tracking-wide text-foreground sm:text-2xl" data-id="element-123" data-mp="19fsjsigisej8">
          Notre garantie «&nbsp;Zéro Risque&nbsp;»
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-foreground/60" data-id="element-124" data-mp="1j52c9zf9zz7v">
          Essayez Musique Prête™ pendant 30 jours. Utilisez-le en classe,
          imprimez les fiches, suivez la progression. Si cela ne vous fait pas
          économiser des heures de stress et que vos élèves ne sont pas plus
          engagés, écrivez-nous&nbsp;: nous vous rembourserons chaque centime. Et
          vous pourrez garder les 5 Bonus comme cadeau pour avoir essayé.
        </p>
      </div>
    </section>;
}